import React from 'react';

import Actions from '@app/store/action';
import Helper from '@app/helper';
import Store from '@app/store';

import I18n from '@module/i18n';

export const validationIndentifiers = {
  get NOT_VALID() {
    return -1;
  },
  get VALID() {
    return 1;
  },
  get DONT_CHECK() {
    return 0;
  },
  get TOO_SHORT() {
    return 'too_short';
  },
  get BLANK() {
    return 'blank';
  },
  get CONFIRM() {
    return 'confirm';
  },
};

export default class Form extends React.Component {
  constructor(props) {
    super(props);

    this.getLocalError = this.getLocalError.bind(this);
    this.resetForm = this.resetForm.bind(this);
    this.updateValue = this.updateValue.bind(this);
    this.validateState = this.validateState.bind(this);
  }

  componentDidUpdate() {
    const { route } = Store.getState();
    if (route.unSavedForm === true && this.isFormDirty === false) {
      Store.dispatch(Actions.Route.setFormState(false));
    }
  }

  validateData(data) {
    for (const key in data) {
      if (['pending'].indexOf(key) > -1) {
        continue;
      }

      if (!data[key] || data[key] === '') {
        return false;
      }
    }

    if (!data.email || !Helper.validateEmail(data.email)) {
      return false;
    }

    return true;
  }

  async validateState(callback) {
    const { data } = this.state;
    await Store.dispatch(Actions.Errors.validateForm(data, this.formName));

    if (callback && typeof callback === 'function') {
      callback();
    }
  }

  resetError(form, key) {
    Store.dispatch(Actions.Errors.resetError(form, key));
  }

  resetForm() {
    for (const key in this.state.data) {
      this.resetError(this.formName, key);
    }
  }

  // Returns an error when the field doesn't pass local validation
  // For now, only email, password and domains
  getLocalError(name) {
    switch (name) {
      case 'email':
      case 'default_recipient_email':
        return Helper.validateEmail(this.state.data[name])
          ? false
          : I18n.t('form.account.error.email.invalid');
      case 'password':
        return this.state.data.password && this.state.data.password.length >= 6
          ? false
          : I18n.t('form.account.error.password.too_short');
      case 'password_confirm':
        return this.state.data.password === this.state.data.password_confirm
          ? false
          : I18n.t('form.account.error.password_confirm.confirm');
      case 'wallpaper_link':
        return Helper.validateUri(this.state.data.wallpaper_link)
          ? false
          : I18n.t('form.profile.error.wallpaper_link.invalid');
      case 'subdomain_name':
        if (this.state.data.subdomain_name.length < 2) {
          I18n.t('form.profile.error.subdomain_name.too_short');
        }

        return /^[a-z\-\d]+$/i.test(this.state.data.subdomain_name)
          ? false
          : I18n.t('form.account.error.subdomain_name.invalid_format');
      default:
        return false;
    }
  }

  getErrorMessage(key) {
    const error = this.getError(key);

    if (typeof error !== 'string') {
      return '';
    }

    return error;
  }

  // Updates a value in the state of the current Component.
  // TODO (6 Oct 2016): refactor this one to accept the state object as well
  updateValue(key, value, ignore = false) {
    return new Promise((resolve) => {
      this.setState(
        {
          data: {
            ...this.state.data,
            [key]: value,
          },
        },
        () => {
          this.resetError(this.formName, key);
          Store.dispatch(Actions.Notification.resetNotification());

          if (!ignore) {
            Store.dispatch(Actions.Route.setFormState(true));
          }
          if (
            this.state.validateFields &&
            this.state.validateFields.indexOf('key') === -1
          ) {
            this.setState({
              validateFields: [...this.state.validateFields, key],
            });
          }
          resolve();
        }
      );
    });
  }

  scrollToError() {
    const elem = document.querySelector('.textfield--invalid');

    if (elem) {
      elem.scrollIntoView();
    }
  }

  get isFormDirty() {
    return undefined;
  }
}
